import { useEffect, useState } from "react";
import axios from "axios";
import "../../Styles/auth/auth.scss";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import isoEventLogo from "./../../assets/images/Logo/Logo-Pazirex-Blue.svg";
import LoginStep from "../../utilities/functions/loginProcessStep";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slices/userSlice";

const registerApiRoute = serverConfig.server.url + apiConfig.api.authControllers.register

const Register = () => {

  const dispatch = useDispatch();
  const { token, roles } = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const headers = { Authorization: "Bearer " + localStorage.tokenreg };
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const registerRequestParams = {
    first_name: firstName,
    last_name: lastName,
    callback_url: window.location.origin + "/",
  }

  const registerAPI = (e) => {

    e.preventDefault(); // Prevent form submission
    setLoading(true);

    axios.post(registerApiRoute, registerRequestParams, { headers })
      .then((response) => {
        setLoading(false);

        if (response.data.status === "success") {
          localStorage.setItem("token", response.data.data.token);
          localStorage.removeItem("tokenfa");
          localStorage.removeItem("mobile");
          dispatch(
            setUser({
              first_name: response.data.data.first_name,
              last_name: response.data.data.last_name,
              token: response.data.data.token,
              roles: response.data.data.user_roles,
            })
          );

          if (localStorage.getItem("token") || token) {
            localStorage.getItem("callBackURL") &&
              (localStorage.getItem("callBackURL") != "/login" ||
                localStorage.getItem("callBackURL") != "/twofa" ||
                localStorage.getItem("callBackURL") != "/register")
              ? window.location.replace(localStorage.getItem("callBackURL"))
              : window.location.replace("/");
          }
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error making API call:", error);
      });
  };

  useEffect(() => {
    let step = LoginStep();
    if (step !== "OK" && step) {
      navigate(step);
    }

    //   if (localStorage.token) {
    //     navigate("/");
    //   } else if (localStorage.tokenfa) {
    //     navigate("/twofa");
    //   } else if (localStorage.tokenreg) {
    //     // navigate("/register");
    //   }
    // } else {
    //   localStorage.clear();
    //   navigate("/login");
    // }
  }, []);

  return (
    <section className="tw-flex tw-items-center tw-justify-center tw-mt-3 border-gray-400 tw-p-5 md:tw-p-8 tw-rounded-2xl tw-max-w-full tw-border-0 md:tw-border tw-w-full md:tw-max-w-[500px]">

      <div className="card-body tw-w-full">

        <img
          src={isoEventLogo}
          className="logo-img d-flex mx-auto tw-w-[55%] tw-h-auto tw-mb-12"
          alt="..."
        />

        <h5 className="tw-text-[20px] tw-font-medium">مشخصات خود را وارد کنید</h5>
        <p className="tw-text-sm tw-font-normal tw-text-[#495057]">اطلاعات شما در پذیرکس محفوظ است. </p>

        <form onSubmit={registerAPI}>

          <input
            type="text"
            style={{ border: '1px solid #CED4DA' }}
            className="tw-w-full tw-p-2 tw-rounded-lg tw-bg-white tw-outline-none tw-mb-2"
            id="firstName"
            placeholder="نام"
            onChange={(e) => {
              setFirstName(e.target.value);
            }}
            autoFocus
          />

          <input
            type="text"
            style={{ border: '1px solid #CED4DA' }}
            className="tw-w-full tw-p-2 tw-rounded-lg tw-bg-white tw-outline-none"
            id="lastName"
            placeholder="نام خانوادگی"
            onChange={(e) => {
              setLastName(e.target.value);
            }}
          />

          <button
            className="btn btn-primary mt-4 tw-w-full md:tw-w-20"
            type="submit"
            disabled={loading || !firstName || !lastName}
          // onClick={registerAPI}
          >
            ورود
            {loading && (
              <span
                className="spinner-border spinner-border-sm ms-1"
                role="status"
                aria-hidden="true"
              />
            )}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Register;
